import {seoMetadata as SeoMetadata} from "@next/utils"
import State from "../../../../models/State"
import {urlSanitiser} from "../../../httpUrlTrimmer"
import {indexMerchandiseURLFilters} from "../../indexFilters"
import {NO_INDEX_NO_FOLLOW_META_ROBOTS} from "../../../../config/constants"
import {NO_INDEX_NO_FOLLOW_MERCHANDISED_CONSTANTS} from "../constants"

interface SeoMetadata {
    title: string
    keywords: string
    description: string
    robots: string
    canonical?: string
}

export const updateMerchandisedSeoMetaDataIndexing = (state: State, replacedSeoMetaData: SeoMetadata): SeoMetadata => {
    const updateSeoMetaData = {...replacedSeoMetaData}
    const {url} = state.request
    const sanitisedUrl = urlSanitiser(url).replace(/\?.*$/, "")

    if (sanitisedUrl.split("/f/").length === 2) {
        const indexFilters = indexMerchandiseURLFilters(
            `/${sanitisedUrl.split("/f/")[1]}`,
            state.seoFilters.merchandisedURLFilterDepthCount,
        )
        if (!indexFilters) {
            updateSeoMetaData.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
        }
    }
    if (NO_INDEX_NO_FOLLOW_MERCHANDISED_CONSTANTS.some(c => sanitisedUrl.includes(c))) {
        updateSeoMetaData.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
    }
    return updateSeoMetaData
}
